import { Component, NgZone } from '@angular/core';
import 'reflect-metadata';
import { Title } from '@angular/platform-browser';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { FirmwareService } from '@shared/state/firmware/firmware.service';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { DefinitionsService } from '@state/definitions/definitions.service';
import { environment } from '@env/environment';

import { ProvisioningService } from '@shared/services/provisioning.service';

import { AppCheck, getToken } from '@angular/fire/app-check'; // ← add this import

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  public env = environment.environment;
  // public isProduction = environment.production;  //comment it when releasing dev build
  public isProduction = false; //un comment it when releasing dev build
  constructor(
    private platform: Platform,
    translateService: TranslateService,
    titleService: Title,
    private definitionsService: DefinitionsService,
    private router: Router,
    private zone: NgZone,
    private prov: ProvisioningService,
    private appCheck: AppCheck, // ← inject AppCheck
  ) {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        const slug = event.url.split('.com').pop();
        if (slug) {
          this.router.navigateByUrl(slug);
        }
      });
    });

    translateService.setDefaultLang('en');
    const curLang = translateService.getBrowserLang();
    if (curLang.includes('sv')) {
      translateService.use('sv');
    } else {
      translateService.use('en');
    }

    const title = environment.production ? '' : environment.environment + '-';
    titleService.setTitle(title + ' CAT TRS Connect');

    this.initializeApp();
  }

  private initializeApp(): void {
    this.platform.ready().then(async () => {
      try {
        // Wait for App Check token before making any Storage requests
        await getToken(this.appCheck, false);
        console.log('App Check ready');
      } catch (error) {
        console.error('App Check failed:', error);
        // Continue anyway — app should still work
        // just Storage requests may fail
      }

      // Now safe to make Storage requests
      this.prov.provisionIfNeeded();
      this.definitionsService.loadDefinitions();

      setTimeout(() => {
        //
      }, 5000);

      this.navigateToStartPage();
    });
  }

  private navigateToStartPage(): void {
    this.router.navigate(['/']);
  }
}
